export const ID = 'web-vitals';

export const name = 'Web Vitals';
